import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

// tslint:disable:max-line-length
function CopyIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props} viewBox="0 0 14 16">
      <path
        d="M11.061 12.799c.316 0 .597-.043.842-.127.245-.085.452-.21.622-.378a1.63 1.63 0 0 0 .387-.632c.09-.253.134-.552.134-.895V4.792H9.524c-.325 0-.58-.092-.762-.277-.183-.185-.274-.438-.274-.759V0H5.106c-.655 0-1.153.17-1.494.508-.34.339-.51.83-.51 1.477v.32h.941c.473 0 .897.066 1.274.198.376.131.738.375 1.086.732l3.589 3.582c.352.352.582.72.691 1.106.11.386.164.805.164 1.26v3.616h.214zm1.905-8.836a.746.746 0 0 0-.134-.304 2.602 2.602 0 0 0-.28-.324L9.937.662a2.38 2.38 0 0 0-.324-.278.768.768 0 0 0-.304-.13l.007 3.348c0 .24.12.361.36.361h3.289zM7.94 16c.664 0 1.165-.17 1.504-.511.338-.341.508-.848.508-1.52V9.022H5.487c-.401 0-.7-.1-.896-.298-.196-.198-.294-.5-.294-.905V3.2H2.012c-.664 0-1.165.172-1.504.515C.169 4.059 0 4.565 0 5.233v8.735c0 .673.17 1.18.508 1.52.339.342.84.512 1.504.512H7.94zm1.898-7.88a1.515 1.515 0 0 0-.174-.38 2.2 2.2 0 0 0-.34-.408l-3.35-3.409a3.31 3.31 0 0 0-.403-.36 1.3 1.3 0 0 0-.385-.201v4.43c0 .22.114.328.341.328h4.31z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export { CopyIcon };
